import { HttpClient } from '../utils/httpClient';

const PATH = {
    read_all: '/root/bidding-credentials',
    update: '/root/bidding-credentials',
    delete: '/root/bidding-credentials',
    read_all_admin: '/admin/bidding-credentials',
};

const Create = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.read_all}`, payload).then(callback).catch(error).finally(next);
};

const ReadAll = (start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.read_all).then(callback).catch(error).finally(next);
};

const GetAllCredentials = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.read_all}/master-bidding-creds`).then(callback).catch(error).finally(next);
};

const Delete = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${id}`).then(callback).catch(error).finally(next);
};

const Update = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.update}/${id}`, payload).then(callback).catch(error).finally(next);
};

// Admin 
const GetAdminCredentials = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.read_all_admin}/master-bidding-creds`, { params }).then(callback).catch(error).finally(next);
};

export const BidCredentialsService = {
    ReadAll,
    Delete,
    Create,
    Update,
    GetAllCredentials
};

export const AdminBidCredentialsService = {
    GetAllCredentials: GetAdminCredentials
};